import { requestTemplate } from 'api';
import { ISimpleGroupForAprove } from 'interfaces';

export type SigningInitiator = {
  id: string;
  name: string;
  email: string;
};

export type SigningState = {
  id?: string;
  document_id?: string;
  signing_state?: ISimpleGroupForAprove[];
  comment?: string;
  decline_comment?: string;
  author?: any;
  author_of_decline?: any;
  status?: 0 | 1 | 2 | null;
  initiator?: SigningInitiator;
  signature_type?: 'qes' | 'ues';
};

//SIGNING

const getSigningState = (
  id: string
) => requestTemplate.get<SigningState[]>(`/signatures/?id=${id}`);

const declineSigning = (
  payload: { comment: string; document_id: string }
) => requestTemplate.post('/signatures/decline/', payload);

const deleteSigning = (
  payload: { document_id: string }
) => requestTemplate.delete<string>(`/signatures/?document_id=${payload.document_id}`);

const createSignature = <T = any> () => requestTemplate.post<T>(`/signatures/users/add_sign/`);

const addSigningParticipants = (
  payload: { document_id: string; signing_state: ISimpleGroupForAprove[] }
) => requestTemplate.post<void>('/signatures/participants/', payload);

const deleteSigningParticipants = (
  payload: { document_id: string; user_ids: string[] }
) => requestTemplate.delete<void>('/signatures/participants/', { data: payload });

const signing = {
  getSigningState,
  declineSigning,
  deleteSigning,
  createSignature,
  addSigningParticipants,
  deleteSigningParticipants,
};

export default signing;
